import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageContent, PageTitle, Button, Link } from 'nallian-shared-ui/lib/components';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import NewOrganisationRole from './NewOrganisationRole';
import EditOrganisationRole from './EditOrganisationRole';
import { INFINITE_SCROLL, ORGANISATION_ROLES_RESOURCE, ACTIONS, SORTED } from '../constants';
import apiRoutes from '../../../app/api/routes';

const OrganisationRolesOverview = () => {
  const { t } = useTranslation();
  const { tag, action } = useParams();

  return (
    <>
      <PageTitle>{t('organisationRoles_plural')}</PageTitle>
      <PageContent>
        <HasRight right="ORGANISATIONROLES.MANAGE.ALL">
          <>
            <NewOrganisationRole open={!tag && action === ACTIONS.NEW} />
            <EditOrganisationRole open={tag && action === ACTIONS.EDIT} />
            <Link to={`/organisation-roles/${ACTIONS.NEW}`}>
              <Button icon="add" content={t('newOrganisationRole')} btnprimary />
            </Link>
          </>
        </HasRight>
        <Table
          url={apiRoutes.organisationRoles()}
          infiniteScroll={INFINITE_SCROLL}
          resource={ORGANISATION_ROLES_RESOURCE}
          sorted={SORTED}
          pageSize={50}
          rootTableProperty="organisationRoles"
          idProp="tag"
          noUserSettings
          resizable
          filtered
        >
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            hasRight="ORGANISATIONROLES.MANAGE.ALL"
            url={`/organisation-roles/${ACTIONS.EDIT}/:tag`}
          />
          <Params.String name="name" width="16rem" minWidth="16rem" grow />
          <Params.String name="tag" width="16rem" minWidth="16rem" grow />
          <Menu width="3.5rem" align="center" hasRight="ORGANISATIONROLES.MANAGE.ALL">
            <Actions.Link
              label="edit"
              icon="edit"
              url={`/organisation-roles/${ACTIONS.EDIT}/:tag`}
            />
            <Actions.Delete url={`${apiRoutes.organisationRoles()}/:tag`} />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

export default OrganisationRolesOverview;
